module.exports = __webpack_public_path__ + "static/media/hackton_co.7a39550f.png";